import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSendResetPasswordRequestArgs,
  BackendResetPasswordRequestStatus,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SendResetPasswordRequest($email: String!) {
    sendResetPasswordRequest(email: $email) {
      id
      status
    }
  }
`;

type Variables = BackendMutationSendResetPasswordRequestArgs;
type Result = BackendResetPasswordRequestStatus;

export const sendResetPasswordRequest = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
